var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeftArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_38552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_38552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.875 23.2947L8.275 16.6947C8.175 16.5947 8.104 16.4864 8.062 16.3697C8.02067 16.253 8 16.128 8 15.9947C8 15.8614 8.02067 15.7364 8.062 15.6197C8.104 15.503 8.175 15.3947 8.275 15.2947L14.875 8.69471C15.0583 8.51138 15.2873 8.41538 15.562 8.40671C15.8373 8.39871 16.075 8.49471 16.275 8.69471C16.475 8.87804 16.5793 9.10704 16.588 9.38171C16.596 9.65704 16.5 9.89471 16.3 10.0947L11.4 14.9947H22.575C22.8583 14.9947 23.096 15.0904 23.288 15.2817C23.4793 15.4737 23.575 15.7114 23.575 15.9947C23.575 16.278 23.4793 16.5154 23.288 16.7067C23.096 16.8987 22.8583 16.9947 22.575 16.9947H11.4L16.3 21.8947C16.4833 22.078 16.5793 22.3114 16.588 22.5947C16.596 22.878 16.5 23.1114 16.3 23.2947C16.1167 23.4947 15.8833 23.5947 15.6 23.5947C15.3167 23.5947 15.075 23.4947 14.875 23.2947Z",
    fill: "#1E293B"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeftArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/left-arrow.995d081c7a524e6ff0e4ca4d44bf324b.svg";